import { getSwapCallV3Params } from './getSwapCallV3Params';
export var SwapCallbackState;
(function (SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
export var getSwapCallback = function (_a) {
    var library = _a.library, account = _a.account, chainId = _a.chainId, trade = _a.trade, allowedSlippage = _a.allowedSlippage, deadline = _a.deadline, protocol = _a.protocol;
    if (protocol === 'V3') {
        var swapCalls = getSwapCallV3Params({
            library: library,
            account: account,
            chainId: chainId,
            trade: trade,
            allowedSlippage: allowedSlippage,
            deadline: deadline,
        });
        return swapCalls;
    }
    return undefined;
};
